<template>
  <div>
    <vs-table ref="table" v-model="selected" search filtered sorted stripe
              :max-items="itemsPerPage" :data="event_data" selectable>

      <template slot="header">
        <div class="p-2">
          <vs-radio v-model="selected_filter" vs-value="all" class="mr-4" vs-name="navbar-type-static"><small>Tümü</small></vs-radio>
          <vs-radio v-model="selected_filter" vs-value="None" class="mr-4" vs-name="navbar-type-static"><small>Duman Algılandı</small></vs-radio>
          <vs-radio v-model="selected_filter" vs-value="0" class="mr-4" vs-name="navbar-type-static"> <small>Orman Yangını</small></vs-radio>
          <vs-radio v-model="selected_filter" vs-value="3" class="mr-4" vs-name="navbar-type-static"> <small>Zirai Yangın</small></vs-radio>
          <vs-radio v-model="selected_filter" vs-value="1" class="mr-4" vs-name="navbar-type-static"> <small>Yangın Değil</small></vs-radio>
          <vs-radio v-model="selected_filter" vs-value="2" class="mr-4" vs-name="navbar-type-static"> <small>Kontrol Altında</small></vs-radio>
          <vs-radio v-model="selected_filter" vs-value="4" class="mr-4" vs-name="navbar-type-static"> <small>Söndürüldü</small></vs-radio>
        </div>
      </template>

      <template slot="thead">
        <vs-th sort-key="indextr">No.</vs-th>
        <vs-th sort-key="event_image">Görüntüle</vs-th>
        <vs-th sort-key="status">Olay Durumu</vs-th>
        <vs-th sort-key="olay_zamani">Olay Zamanı</vs-th>
        <vs-th sort-key="bolge_adi">Bölge</vs-th>
        <vs-th sort-key="isletme_adi">İşletme</vs-th>
        <vs-th sort-key="seflik_adi">Şeflik</vs-th>
        <vs-th sort-key="kule_adi">Kule</vs-th>
        <vs-th sort-key="yangin_koordinati">Yangın Koordinatı</vs-th>
        <vs-th>İşlemler</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :class="[getRowColor(tr.event.status)]" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <p class="product-category font-medium truncate">{{ indextr }}</p>
          </vs-td>
          <vs-td class="flex justify-center">
            <span class="product-category" v-tooltip="'Fotoğrafı görüntüle'" @click="toggleImage(tr.event)"><i class="fas fa-image" ></i></span>
            <span class="product-category ml-4"  v-tooltip="'Haritada görüntüle'" @click="showOnMap(tr.event)"><i class="fas fa-map-marker-alt"></i></span>
            <logs-popup v-tooltip="'İşlemler'" :event="tr.event" class="ml-4" />

          </vs-td>
          <vs-td >
            <p class="product-category">
              <i  class="fas fa-circle mr-2"></i>
              {{ getStatusText(tr.event.status) }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.event.olay_zamani | formatDate }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{tr.bolge.name}}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{tr.isletme.name}}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.seflik.name }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.kule.name }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ getEventCoordString(tr.event.yangin_koordinati) }}</p>
          </vs-td>

          <vs-td class="whitespace-no-wrap z-20 text-center">
            <edit-event-popup v-tooltip="getStatusText(tr.event.status)" :status="tr.event.status" :event="tr.event" />
            <feather-icon v-if="activeUserInfo.role === 'superadmin'" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.event.id)" />

          </vs-td>

        </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <pagination
      v-model="page"
      :per-page="itemsPerPage"
      :records="count" @paginate="clickCallback"
    >
    </pagination >
  </div>
</template>
<script>

import EditEventPopup from '../layouts/components/navbar/components/EditEventPopup'
import LogsPopup from '../layouts/components/navbar/components/LogsPopup'
import NotificationDropDown from '../layouts/components/navbar/components/NotificationDropDown'
import moment from 'moment'
import Pagination from 'vue-pagination-2'

export default {
  data () {
    return {
      selected: [],
      page: 1,
      count: 0,
      itemsPerPage: 24,
      isMounted: false,
      selected_filter: 'all'
    }
  },
  name: 'Home',
  components: {
    EditEventPopup,
    Pagination,
    NotificationDropDown,
    LogsPopup
  },
  mounted () {
    this.getEventList()
    this.intervalObject = setInterval(() => {
      if (this.alarm_mode) {
        this.getEventList()
      }
    }, 30000)
  },
  beforeDestroy () {
    clearInterval(this.intervalObject)
  },
  watch: {
    selected_filter (val) {
      console.log('filter changed', val)
    }
  },
  computed: {
    getVideoFrame () {
      return this.image_to_show
    },
    alarm_mode () {
      return this.$store.state.alarm_mode
    },
    showPopup () { return this.$store.state.showPopup },
    event_data_state () {
      return this.$store.state.event_data
    },
    event_data_object () {
      return JSON.parse(JSON.stringify(this.event_data_state))
    },
    event_data () {
      let event_data_ = this.event_data_object
      event_data_ = event_data_.sort((a, b) => {
        const diff = new Date(this.formatDateOrder(a.event.olay_zamani)) - new Date(this.formatDateOrder(b.event.olay_zamani))
        return diff
      }).reverse()
      if (this.selected_filter !== 'all') {
        return event_data_.filter((event) => {
          if (event.event.status === this.selected_filter) {
            return event.event
          }
        })
      } else {
        return event_data_.filter((event) => {
          return event.event
        })
      }

    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.event_data.length
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    clickCallback () {
      console.log('page', this.page)
      this.getEventList()
    },
    formatDateOrder (value) {
      if (value) {
        return moment(String(value), 'DDMMYYYY_HHmmss').toDate()
      }
    },
    openConfirm (text, accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Onayla',
        text,
        acceptText: 'Onayla',
        cancelText: 'Vazgeç',
        accept,
        cancel
      })
    },
    deleteData (id) {
      this.openConfirm('Bu olayı silmek istediğinize emin misiniz?', () => {
        this.$vs.loading()
        const payload = {
          id
        }
        this.$store.dispatch('deleteEvent', payload).then(() => {
          this.getEventList()
          this.$vs.loading.close()
        }).catch(err => {
          this.$vs.loading.close()
          console.error(err)
        })
      }, () => {})
    },
    ConvertDDToDMS (D) {
      const result = [0 | D, '° ', 0 | (D < 0 ? D =  -D : D) % 1 * 60, '\' ', 0 | D * 60 % 1 * 60, '" '].join('')
      return result
    },
    getEventCoordString (coords) {
      if (coords === '') {
        return '-'
      } else {
        const lat = coords.split(' ')[0]
        const longti = coords.split(' ')[1]

        const latDMS = this.ConvertDDToDMS(lat)
        const lonDMS = this.ConvertDDToDMS(longti)

        return  `${latDMS} ${lonDMS}`
      }
    },
    toggleImage (event) {
      console.log('got event', event)
      this.$store.commit('TOGGLE_POPUP', !this.showPopup)
      this.$store.commit('SET_EVENT_IMAGE', this.getEventImageUrl(event.event_image))
      console.log('popup', this.showPopup)
    },
    showOnMap (event) {
      console.log(event)
      this.$router.push({name: 'event-detail', params: {id: event.id }})
    },
    getStatusText (status) {
      switch (status) {
      case 'None':
        return 'Duman algılandı'

      case '0':
        return 'Orman Yangını'

      case '1':
        return 'Yangın değil'

      case '2':
        return 'Kontrol altında'

      case '3':
        return 'Zirai Yangın'

      case '4':
        return 'Söndürüldü'
      }
    },
    getEventList () {
      const payload = {
        page: this.page,
        items: this.itemsPerPage
      }

      this.$store.dispatch('getEvents', payload)
        .then((response) => {
          console.log('event list', response)
          this.count = response.data.count
          this.isMounted = true
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error', error)
        })
    },
    getEventImageUrl (url) {
      if (!url.startsWith('https')) {
        return 'https://api.arftower.com'.concat(url)
      } else {
        return url
      }
    },
    getRowColor (status) {
      return {
        'initial'   : status === 'None',
        'yangin'   : status === '0',
        'yangin-degil'   : status === '1',
        'yangin-kontrol'   : status === '2',
        'sogutma' : status === '3',
        'yangin-sondu' : status === '4'
      }
    }
  }
}
</script>
<style lang="scss">
.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  background: #f7f7f7;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 4px 8px;
}
.vs-con-table .vs-table--header .vs-table--search {
  padding: 0.5rem;
}
.product-category {
  font-size: 12px !important;
  text-align: center;
}
th .sort-th, th .vs-table-text {

  -webkit-box-pack: center;
  justify-content: center;
}
.con-tablex {
    overflow: visible;
  }
  .product-img {
    max-width: 70px;
  }
  .fa-circle {
    border-radius: 50%;
  }
  .initial {
    .fa-circle {
      color: #ffea00 !important;
      animation: pulse-yellow 2s infinite;
    }

    td {
      color: #555;
    }


  }
  .tooltip {
    display: block !important;
    z-index: 10000;
  }

  .tooltip .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
  }

  .tooltip[x-placement^="top"] {
    margin-bottom: 5px;
  }

  .tooltip[x-placement^="top"] .tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
  }

  .tooltip[x-placement^="bottom"] {
    margin-top: 5px;
  }

  .tooltip[x-placement^="bottom"] .tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
  }

  .tooltip[x-placement^="right"] {
    margin-left: 5px;
  }

  .tooltip[x-placement^="right"] .tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }

  .tooltip[x-placement^="left"] {
    margin-right: 5px;
  }

  .tooltip[x-placement^="left"] .tooltip-arrow {
    border-width: 5px 0 5px 5px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }

  .tooltip[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  .tooltip[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }


@keyframes pulse-black {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.blob.white {
  background: white;
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
  animation: pulse-white 2s infinite;
}

@keyframes pulse-white {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.blob.red {
  background: rgba(255, 82, 82, 1);
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}

.blob.orange {
  background: rgba(255, 121, 63, 1);
  box-shadow: 0 0 0 0 rgba(255, 121, 63, 1);
  animation: pulse-orange 2s infinite;
}

@keyframes pulse-orange {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 121, 63, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 121, 63, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 121, 63, 0);
  }
}

.blob.yellow {
  background: rgba(255, 177, 66, 1);
  box-shadow: 0 0 0 0 rgba(255, 177, 66, 1);
  animation: pulse-yellow 2s infinite;
}

@keyframes pulse-yellow {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 177, 66, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 177, 66, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 177, 66, 0);
  }
}

.blob.blue {
  background: rgba(52, 172, 224, 1);
  box-shadow: 0 0 0 0 rgba(52, 172, 224, 1);
  animation: pulse-blue 2s infinite;
}

@keyframes pulse-blue {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(52, 172, 224, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(52, 172, 224, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(52, 172, 224, 0);
  }
}

.blob.green {
  background: rgba(51, 217, 178, 1);
  box-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
  animation: pulse-green 2s infinite;
}

@keyframes pulse-green {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(51, 217, 178, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0);
  }
}

.blob.purple {
  background: rgba(142, 68, 173, 1);
  box-shadow: 0 0 0 0 rgba(142, 68, 173, 1);
  animation: pulse-purple 2s infinite;
}

@keyframes pulse-purple {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(142, 68, 173, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(142, 68, 173, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(142, 68, 173, 0);
  }
}
</style>
